import request from '@/utils/request'

export const getTableData = params =>
  request.post('/customer-api/customer/blacklist/page', params)
// 新增用户查看客户日志
export const getAddlog = params =>
  request.post('/customer-api/company-search-logs/add', params)
// 删除黑名单
export const removeBlackList = id =>
  request.get(`/customer-api/customer/blacklist/remove/${id}`)

// 下载
export const download = params =>
  request.post(`/customer-api/customer/blacklist/export`, params, {
    responseType: 'blob',
  })
